// API Configuration - Environment-based endpoint management
// To switch between local and production, update REACT_APP_ENV in .env file:
// - Set to 'local' for local development (API backend at localhost:8084)
// - Set to 'production' for deployed environment (API backend at apigateway.thedeepvbc.com)

// Determine base URL from environment variables
const env = process.env.REACT_APP_ENV || 'local';
const LOCAL_BASE_URL = process.env.REACT_APP_API_BACKEND_LOCAL_URL || 'http://localhost:8084';
const PRODUCTION_BASE_URL = process.env.REACT_APP_API_BACKEND_PRODUCTION_URL || 'https://apigateway.thedeepvbc.com';

// Select base URL based on environment
const BASE_URL = env === 'production' ? PRODUCTION_BASE_URL : LOCAL_BASE_URL;
const API_BASE = `${BASE_URL}/api/v2/thedeep`;

console.log(`API Configuration: Using ${env} environment with base URL: ${BASE_URL}`);

// API Endpoints (Updated to v2 structure)
exports.sendmail = `${API_BASE}/email`;
exports.cohortCollections = `${API_BASE}/cohort/collections`;
exports.tourneyCollections = `${API_BASE}/tourney/collections`;
exports.generalCollections = `${API_BASE}/general/collections`;
exports.events = `${API_BASE}/register/listevents`;

// General API key for accessing server side REST calls via apigateway
// These values are loaded from environment variables in .env file
exports.apiKey = process.env.REACT_APP_API_KEY;
exports.email = process.env.REACT_APP_EMAIL;

// Keys and IDs for Google Calendar
// These values are loaded from environment variables in .env file
exports.apiKeyGoogleCalendar = process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY;
exports.calendarTheDeep = process.env.REACT_APP_CALENDAR_THE_DEEP;
exports.calendarBirthdays = process.env.REACT_APP_CALENDAR_BIRTHDAYS;
exports.calendarPractice = process.env.REACT_APP_CALENDAR_PRACTICE;
exports.calendarTourney = process.env.REACT_APP_CALENDAR_TOURNEY;
exports.calendarDropin = process.env.REACT_APP_CALENDAR_DROPIN;

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_API_KEY',
  'REACT_APP_EMAIL',
  'REACT_APP_GOOGLE_CALENDAR_API_KEY'
];

const missingEnvVars = requiredEnvVars.filter(varName => !process.env[varName]);
if (missingEnvVars.length > 0) {
  console.error('Missing required environment variables:', missingEnvVars.join(', '));
  console.error('Please check your .env file and ensure all required variables are set.');
}

